import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import LoginSlice from "./slices/Login";

const rootReducer = combineReducers({
  LoginSlice,
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
